import { useState, useCallback } from 'react';
import CategoryFilters, { useCategoryFilters } from './CategoryFilters';
import { Input } from './ui/input';
import { ordersAPI, productsAPI } from '../lib/api';
import { fetchFilteredOrders, matchesOrderItems } from '../lib/categoryFilters';

export function useOrderItemFilters() {
  const categories = useCategoryFilters();
  const [itemSearch, setItemSearch] = useState('');
  const active = Boolean(itemSearch.trim() || categories.category || categories.subcategory);
  const categoryIds = categories.categoryIds;
  const fetchOrders = useCallback(async params => {
    if (!active) return ordersAPI.getAll(params);
    let products = [];
    if (categoryIds) {
      // Resolve legacy order snapshots, which store product_id but not category.
      let page = 1;
      let pages = 1;
      do {
        const response = await productsAPI.getAll({ page, limit: 100, include_inactive: true, light_mode: false });
        const data = response.data;
        products.push(...(Array.isArray(data) ? data : data.products || []));
        pages = data.pages || 1;
        page += 1;
      } while (page <= pages);
    }
    const data = await fetchFilteredOrders(ordersAPI, params,
      order => matchesOrderItems(order, itemSearch, categoryIds, products), params.limit);
    return { data };
  }, [active, categoryIds, itemSearch]);
  return { categories, itemSearch, setItemSearch, fetchOrders };
}

export default function OrderItemFilters({ filters, onClear }) {
  return (
    <div className="space-y-3">
      <CategoryFilters filters={filters.categories} onClear={() => { filters.setItemSearch(''); onClear?.(); }} />
      <label className="block max-w-md text-sm space-y-1">
        <span className="block">Item in order (product name or SKU)</span>
        <Input value={filters.itemSearch} onChange={event => filters.setItemSearch(event.target.value)}
          placeholder="Search an item in orders..." className="input-admin" />
      </label>
    </div>
  );
}
